module.exports = __webpack_public_path__ + "static/media/0_2018_09_10.124018b2.jpg";